import { scaleLog } from "d3";

function formatPower(x, limit) {
  const e = Math.log10(x);
  if (e !== Math.floor(e)) return null;
  if (x > limit) return x;
  if (e < -5) {
    return "0";
  }
  return `10${`${e}`.replace(/./g, (c) => "⁰¹²³⁴⁵⁶⁷⁸⁹"[c] || "⁻")}`;
}

function getFrequencyTicks(min, max) {
  const axisScale = scaleLog().domain([min, max]).range([0, 1]);
  return axisScale
    .ticks()
    .map((x) => {
      const tick = formatPower(x, 0.0001);
      return {
        label: tick,
        helpText: `frequency: ${tick}`,
        tick,
        y: axisScale(x),
      };
    })
    .filter((x) => x.tick);
}
export default getFrequencyTicks;
